import { render, staticRenderFns } from "./TpmAxisCoordinateDataAcdEdit.vue?vue&type=template&id=19e24cbc&"
import script from "./TpmAxisCoordinateDataAcdEdit.vue?vue&type=script&lang=js&"
export * from "./TpmAxisCoordinateDataAcdEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports